export const ENhrStatus = {
  PENDING: "Pending",
  UPLOADING: "Uploading",
  UPLOAD_FAILED: "UploadFailed",
  SENT: "Sent",
} as const;
